module.exports = __webpack_public_path__ + "static/img/202201.83b676e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/202201.jpg
// module id = BgQ4
// module chunks = 0